module.exports = __webpack_public_path__ + "img/wx.5930d0d9.png";